/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_2_TitleInputs */

const en_pc_rv_2_title = /** @type {(inputs: Pc_Rv_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instantly familiar`)
};

const zh_pc_rv_2_title = /** @type {(inputs: Pc_Rv_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一上手就熟悉`)
};

/**
* | output |
* | --- |
* | "Instantly familiar" |
*
* @param {Pc_Rv_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_2_title = /** @type {((inputs?: Pc_Rv_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_2_title(inputs)
	return zh_pc_rv_2_title(inputs)
});
export { pc_rv_2_title as "pc.rv.2.title" }